export default __webpack_public_path__ + "static/media/thumbnail.75385d79.png";